import ReportingContainer from "./containers/ReportingContainer";
import "./SCSS/styles.css";
export default ReportingContainer;
